export const WorkerStatuses = {
  NOT_IN_AREA: 'not_in_area',
  APPLICATION_DENIED: 'application_denied',
  APPLIED: 'applied',
  ACCREDITATIONS_COMPLETE: 'accreditations_complete',
  PHONE_INTERVIEW: 'phone_interview',
  APPLICATION_REVIEW: 'application_review',
  READY_FOR_ONBOARDING: 'ready_for_onboarding',
  DETAILS_COMPLETE: 'details_complete',
  READY_FOR_IN_PERSON_INTERVIEW: 'ready_for_in_person_interview',
  IN_PERSON_INTERVIEW_PENDING: 'in_person_interview_pending',
  BACKGROUND_CHECK_IN_PROGRESS: 'background_check_in_progress',
  BACKGROUND_CHECK_CLEAR: 'background_check_clear',
  CONFIRMED_MOBILE: 'confirmed_mobile',
  POSITIONS_SELECTED: 'positions_selected',
  INTERVIEW_SCHEDULED: 'interview_scheduled',
  START_BACKGROUND_CHECK: 'start_background_check',
  TRAINING_COMPLETE: 'training_complete',
  IN_PERSON_INTERVIEW_COMPLETED: 'in_person_interview_completed',
  ONBOARDED_PAYOUT_INFO: 'onboarded_payout_info',
  GENERAL_AVAILABILITY_SET: 'general_availability_set',
  OFFER_ACCEPTED: 'offer_accepted',
  REFERENCES_COMPLETED: 'references_completed',
  HR_FORMS_STARTED: 'hr_forms_started',
  HR_FORMS_COMPLETED: 'hr_forms_completed',
  READY_FOR_TRAINING: 'ready_for_training',
  OFFER_SENT: 'offer_sent',
  BCA_FORMS_STARTED: 'bca_forms_started',
  HIRED: 'hired',
  PAST_EXPERIENCES_SET: 'past_experiences_set',
};
